import { RotateCcw } from "lucide-react";
import { ACTIONS, AREAS } from "@/data/strategy";

const label = (w) => (w === 0 ? "Ignora" : w < 1 ? "Meno peso" : w === 1 ? "Standard" : "Più peso");

export const WeightsEditor = ({ weights, onChange }) => {
  const set = (id, v) => onChange({ ...weights, [id]: v });
  const changed = Object.values(weights).some((w) => w !== 1);
  return (
    <div className="card p-6 sm:p-8 no-print" data-testid="weights-editor">
      <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
        <div>
          <p className="eyebrow">Il tuo giudizio</p>
          <h2 className="font-serif text-2xl sm:text-3xl font-semibold text-[#382E2B] mt-1">Pesi delle azioni</h2>
          <p className="text-sm text-[#7A6B63] mt-2 max-w-xl">Il punteggio di ogni azione viene moltiplicato per il peso che scegli (×0 la esclude, ×2 la raddoppia). Vale per tutte le compilazioni su questo tablet.</p>
        </div>
        <button className="btn btn-ghost !min-h-[44px] text-sm" onClick={() => onChange({})} disabled={!changed} data-testid="weights-reset-btn">
          <RotateCcw size={16} /> Ripristina
        </button>
      </div>
      <div className="grid gap-5 sm:grid-cols-2">
        {ACTIONS.map((a) => {
          const w = weights[a.id] ?? 1;
          return (
            <div key={a.id} className="rounded-2xl border border-[#E3D5C3] p-4" data-testid={`weight-row-${a.id}`}>
              <div className="flex justify-between items-start gap-3">
                <div>
                  <p className="font-semibold text-[#2C221E] leading-snug">{a.title}</p>
                  <p className="text-xs uppercase tracking-wider text-[#8A7970] mt-1">{AREAS[a.area]}</p>
                </div>
                <span className={`flex-none font-serif text-xl font-semibold ${w === 1 ? "text-[#8A7970]" : "text-[#C85A32]"}`} data-testid={`weight-value-${a.id}`}>×{w}</span>
              </div>
              <input type="range" min="0" max="2" step="0.25" value={w} onChange={(e) => set(a.id, Number(e.target.value))}
                className="w-full mt-3 h-10 accent-[#C85A32]" aria-label={`Peso: ${a.title}`} data-testid={`weight-slider-${a.id}`} />
              <p className="text-xs text-[#7A6B63]">{label(w)}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
